module.exports = __webpack_public_path__ + "static/media/1.fd48c17b.png";